<template>
	<div class="max-content">
		<top :title="title" :color="color"></top>
		<div class="ppts">
			<div class="item" v-for="(value, key, index) in pptList" :key="index">
				<img :src="value.banner" />
				<span class="name">{{ value.name }}</span>
				<!-- <van-button :url="value.bind_url" icon="down" color="#d2020d" size="small">下载</van-button> -->
				<div style="margin-top:5px;" v-if="value.bind_url">
					<van-button :url="value.bind_url" icon="down" color="#d2020d" size="small"
						style="margin-right:20px">下载</van-button>
					<!-- <van-button icon="envelop-o" size="small" plain color="#d2020d"
						@click="inputEmail(value.bind_url)">发送到邮箱</van-button> -->
				</div>
			</div>
		</div>
		<van-overlay :show="show" @click="show = false">
                <div class="wrapper">
                    <div class="block" @click.stop>
                        <van-field v-model="email" label="邮箱" placeholder="我们将发送邀请函至您填写的邮箱"
                            label-width="50px"></van-field>
                        <van-button round @click="sendPdf">确定发送</van-button>
                    </div>
                </div>
            </van-overlay>
	</div>
</template>
<script>
import { PPTs, ButtonDetail,sendPPTEmail } from '../../../config/interface.js'
import Top from "../components/Top";
export default {
	components: {
		Top
	},
	data() {
		return {
			meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id,
			button_id: this.$route.query.button_id ? this.$route.query.button_id : this.$route.query.b_id,
			pptList: [],
			title: '',
			color: '#FFFFFF',
			show: false,
            email: localStorage.getItem('email') ? localStorage.getItem('email') : '',
            send_url: '',
		}
	},
	mounted() {
		this.getPPTs();
		this.getButtonData();
	},
	methods: {
		getPPTs() {
			const url = PPTs;
			let params = {
				meeting_id: this.meeting_id,
				button_id: this.button_id
			}
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						this.pptList = res.data;

					}
				})
		},
		goTo(url) {
			window.location.href = url;
		},
		inputEmail(url) {
            this.show = true;
            this.send_url = url;
        },
        sendPdf() {
            if (this.checkEmail(this.email)) {
                const url = sendPPTEmail;
                const method = 'POST';
                localStorage.setItem('email', this.email);
                let params = {
                    ppt_url: this.send_url,
                    email: this.email,
                    type: 'pdf模板'

                };
                fetch(url, params, method)
                    .then((res) => {
                        if (res.code == 0) {
                            common.toast("发送成功", 1000, "success", () => {
                                this.show = false;
                            });
                        }
                        else {
                            common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => {
                            })
                        }
                    })

            }

        },
        checkEmail(val) {
            // let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
            if (val === "") { //输入不能为空
                common.toast('请您填写邮箱', 1000)
                return false;
            } else {
                return true;
            }
        },
		//获取按钮信息
		getButtonData() {
			if (this.button_id) {
				const url = ButtonDetail;
				let params = {
					button_id: this.button_id
				}
				const method = "POST";
				fetch(url, params, method)
					.then((res) => {
						if (res.code == 0) {
							document.title = res.data.share_title;
							this.title = res.data.name;
							if (res.data.theme_color_hex) {
								this.color = res.data.theme_color_hex
							} else {
								this.color = '#901D22'
							}
							if (common.is_weixin()) {
								let data = res.data;
								common.wxShare(data.share_title, data.share_sub_title, data.share_img);
							}
						}
					})

			}
		}

	}
}
</script>
<style lang="scss" scoped>
.ppts {
	margin: 15px;

	.item {
		margin-bottom: 20px;

		img {
			width: 100%;
		}

		.name {
			font-size: 18px;
			line-height: 36px;
		}

		// .van-button{
		//     float:right;
		// }

	}
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.block {
    width: 90%;
    height: 120px;
    background-color: #fff;
    padding: 10px;
    text-align: center;

    p {
        font-size: 14px;
    }

    .van-field {
        border-width: 1px;
    }

    .van-button {
        text-align: center;
        background: $color-main;
        color: white;
        margin-top: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/PPTs.vue